import { InfoSectionSupportSubscript } from "./SupportSubscript"

import { usePageLayoutState } from "@utils/layout"
import { useIsBreakpoint } from "@utils/V2/screen"
import React, { useEffect, useRef, useState } from "react"

interface Props {
  children: React.ReactNode
}

export const InfoSectionStickyFooter = ({ children }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const isMobile = useIsBreakpoint("mobile")
  const [isStickyEnabled, setIsStickyEnabled] = useState<boolean>(false)
  const { calculateStickyFooterHeight } = usePageLayoutState()

  useEffect(() => {
    const onScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect()
        const viewportHeight =
          globalThis.innerHeight || document.documentElement.clientHeight

        // Check if the bottom edge of the div is at or past the bottom of the viewport
        const stickyElement = rect.bottom >= viewportHeight
        if (stickyElement && !isStickyEnabled) {
          setIsStickyEnabled(true)
          calculateStickyFooterHeight(85)
        }
        if (!stickyElement && isStickyEnabled) {
          setIsStickyEnabled(false)
          calculateStickyFooterHeight(-85)
        }
      }
    }

    if (isMobile) {
      onScroll()
      globalThis.addEventListener("scroll", onScroll)
    }

    return () => globalThis.removeEventListener("scroll", onScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isStickyEnabled])

  return (
    <div
      ref={containerRef}
      data-testid="sticky-footer"
      className="sticky bottom-0 left-0 right-0 -mx-2 flex flex-col gap-12 border-t border-charcoal/20 bg-white pb-16 pt-12 [&_button]:transition-[opacity,transform] [&_button_*]:transition-[opacity,transform]"
    >
      {children}
      <div className="hidden sm:block">
        <InfoSectionSupportSubscript />
      </div>
    </div>
  )
}
